import Query from '../../../../components/Report';

export const query = () => new Query('opportunities-search-keyword-clusters');
